import './index.css'

const Header = () => (
  <header className="header">
    <h1 className="header-title">Header</h1>
  </header>
)

export default Header
